import { render, staticRenderFns } from "./myWebsiteMonitor.vue?vue&type=template&id=36027252&scoped=true"
import script from "./myWebsiteMonitor.vue?vue&type=script&lang=js"
export * from "./myWebsiteMonitor.vue?vue&type=script&lang=js"
import style0 from "./myWebsiteMonitor.vue?vue&type=style&index=0&id=36027252&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36027252",
  null
  
)

export default component.exports